import PageLayout from "./PageLayout";

export { PageLayoutScrollContext } from "./PageLayout";

export default PageLayout;
